<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { ProjectClonerViewModel } from '@Projects/Components/ProjectCloner';
    

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class ProjectCloner extends Vue
    {
        get vm(): ProjectClonerViewModel { return this.$props.viewModel as ProjectClonerViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }
        get cloning(): boolean { return this.vm.cloning; }
        get nameError(): string | null { return this.vm.nameError; }

        get name(): string | null { return this.vm.cloneName; }
        set name(val: string | null) { this.vm.cloneName = val; }

        handleFormSubmit()
        {
            this.vm.cloning = true;

            this.$emit("clone-project", this.vm.sourceId, this.name);
        }

        close()
        {
            this.vm.close();
        }
    }

</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Clone</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form id="project-cloner-form" @submit.prevent="handleFormSubmit">
                            <div class="form-group">
                                <label>Clone Name (2-100 characters):</label>
                                <input v-model.trim="name" type="text" class="form-control" required minlength="2" maxlength="100" />
                                <div v-if="nameError" class="error">{{nameError}}</div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer text-right">
                        <button type="button" @click="close" :disabled="cloning" class="btn btn-secondary">Close</button>
                        <button type="submit" form="project-cloner-form" :disabled="cloning"  class="btn btn-primary">
                            {{cloning ? 'Cloning...' : 'Clone'}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>